import { moduleProviderFactory } from "core/providers";
import { PatientMissingDocsSearch, PatientMissingDocsPreview } from "application/patient-missing-docs/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.patient-missing-docs",
				pattern: "/patient-missing-docs",
                children: [
					{
						name: "master.app.main.patient-missing-docs.search",
						pattern: "/search",
						authorization: "facilityOrderSection.read",
						component: PatientMissingDocsSearch,
						tabTitle: "MENU.PATIENT_MISSING_DOCS_SUB",
					},
                ]
            },
			{
				name: "master.app.main.patient-missing-docs.preview",
				pattern: "/preview/:id",
				component: PatientMissingDocsPreview,
				authorization: "facilityOrderSection.update",
				data: {
					crumbs: [
						{
							title: "PATIENT_MISSING_DOCS.CRUMB.PATIENT_PREVIEW",
							route: 'master.app.main.patient-missing-docs.preview'
						}
					],
					back: "master.app.main.patient-missing-docs.search"
				},
			},
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.PATIENT_MISSING_DOCS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.patient-missing-docs.search",
						order: 5,
					}
				]
			},
        ]
    });
})();
